"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getEwsRequestDateString_1 = require("owa-mail-store/lib/services/utils/getEwsRequestDateString");
var getServiceContextFolderId_1 = require("owa-mail-store/lib/services/utils/getServiceContextFolderId");
var applyConversationActionRequest_1 = require("owa-service/lib/factory/applyConversationActionRequest");
var conversationAction_1 = require("owa-service/lib/factory/conversationAction");
var itemId_1 = require("owa-service/lib/factory/itemId");
var applyConversationActionOperation_1 = require("owa-service/lib/operation/applyConversationActionOperation");
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
/**
 * Create a ConversationAction with delete params for a given conversation.
 * @param conversationContext the conversation context to be deleted
 * @param contextFolderId  the folder where the conversations will be deleted from
 * @param disposalType  the disposal type
 * @returns a ConversationAction
 */
function createDeleteConversationAction(conversationContext, contextFolderId, disposalType) {
    return conversationAction_1.default({
        Action: 'Delete',
        ConversationId: itemId_1.default({ Id: conversationContext.conversationId }),
        DeleteType: disposalType,
        ConversationLastSyncTime: getEwsRequestDateString_1.default(conversationContext.conversationLastSyncTimeStamp),
        SuppressReadReceipts: true,
        ContextFolderId: getServiceContextFolderId_1.default(contextFolderId),
    });
}
/**
 * Worker method which converts the provided data into a delete ApplyConversationActionRequest.
 * @param conversationContexts the conversation contexts to be deleted
 * @param contextFolderId  the folder where the conversations will be deleted from
 * @param disposalType the disposal type
 * @returns an ApplyConversationActionRequest
 */
function configureRequestBody(conversationContexts, contextFolderId, disposalType) {
    var conversationActions = conversationContexts.map(function (conversationContext) {
        return createDeleteConversationAction(conversationContext, contextFolderId, disposalType);
    });
    return applyConversationActionRequest_1.default({
        ConversationActions: conversationActions,
        ReturnMovedItemIds: false,
    });
}
/**
 * The service which calls the ApplyConversationAction with delete parameters.
 * @param conversationContexts the conversation contexts to be deleted
 * @param contextFolderId  the folder where the conversations will be deleted from
 * @param disposalType the disposal type
 */
function deleteConversationService(conversationContexts, contextFolderId, disposalType, options) {
    var requestBody = configureRequestBody(conversationContexts, contextFolderId, disposalType);
    return applyConversationActionOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: requestBody,
    }, options).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.default = deleteConversationService;
//# sourceMappingURL=deleteConversationService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/services/deleteConversationService.js
// module id = 5580
// module chunks = 62